// src/components/Header.js
import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import HashLink from "./HashLink";

const NAV = {
  ar: {
    services: "الخدمات",
    how: "كيف تعمل",
    about: "من نحن",
    contact: "تواصل معنا",
  },
  en: {
    services: "Services",
    how: "How It Works",
    about: "About",
    contact: "Contact",
  },
};

export default function Header({ lang, setLang }) {
  const isAr = lang === "ar";
  const t = NAV[isAr ? "ar" : "en"];
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  const linkClass =
    "text-gray-700 hover:text-[#006C35] transition-colors";
  const mobileLinkClass =
    "block py-3 text-gray-700 hover:text-[#006C35] hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0";

  return (
    <header
      className="bg-white shadow-sm sticky top-0 z-50"
      dir={isAr ? "rtl" : "ltr"}
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" onClick={closeMenu}>
          <div className="w-16 h-16 bg-[#006C35] rounded-lg flex items-center justify-center">
            <img
              src="/logo512.png"
              alt="TrustFix"
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-[#535c79]">TrustFix</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <HashLink to="/#services" className={linkClass}>
            {t.services}
          </HashLink>
          <HashLink to="/#how-it-works" className={linkClass}>
            {t.how}
          </HashLink>
          <Link to="/about" className={linkClass}>
            {t.about}
          </Link>
          <Link to="/contact" className={linkClass}>
            {t.contact}
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          {setLang && (
            <div className="inline-flex rounded-full border border-gray-300 overflow-hidden">
              <button
                onClick={() => setLang("ar")}
                className={`px-3.5 py-1.5 text-sm font-semibold transition-colors ${
                  isAr ? "bg-[#006C35] text-white" : "text-gray-600"
                }`}
              >
                العربية
              </button>
              <button
                onClick={() => setLang("en")}
                className={`px-3.5 py-1.5 text-sm font-semibold transition-colors ${
                  !isAr ? "bg-[#006C35] text-white" : "text-gray-600"
                }`}
              >
                English
              </button>
            </div>
          )}
          <button
            className="md:hidden"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? (
              <X size={24} className="text-[#006C35]" />
            ) : (
              <Menu size={24} className="text-[#006C35]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {open && (
        <nav className="md:hidden border-t border-gray-100 bg-white">
          <div className="max-w-7xl mx-auto px-4 py-3">
            <HashLink
              to="/#services"
              className={mobileLinkClass}
              onClick={closeMenu}
            >
              {t.services}
            </HashLink>
            <HashLink
              to="/#how-it-works"
              className={mobileLinkClass}
              onClick={closeMenu}
            >
              {t.how}
            </HashLink>
            <Link to="/about" className={mobileLinkClass} onClick={closeMenu}>
              {t.about}
            </Link>
            <Link to="/contact" className={mobileLinkClass} onClick={closeMenu}>
              {t.contact}
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}